export default __webpack_public_path__ + "locales/az/MainBar.json?hash=57d5d56e59604a7607692258137ca05a";